export default "__VITE_ASSET__0e6ccf8b__"